import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-xs text-muted flex justify-content-end align-items-baseline" }

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import TooltipText from '@/components/tooltip/TooltipText.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'UsdInputValue',
  props: {
    usdAmount: null,
    usdLoss: null,
    isLoading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  usdAmount: number;
  usdLoss?: number;
  isLoading?: boolean;
}


const { t } = useI18n();
const amount = computed(() => `~ $${props.usdAmount.toFixed(2)}`);
const labelText = computed(() => ` (-$${Math.abs(props.usdLoss || 0).toFixed(2)})`);
const tooltipText = computed(() => t('swap.estimatedDifferenceTooltip'));

return (_ctx: any,_cache: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!__props.isLoading)
      ? (_openBlock(), _createBlock(_component_Skeleton, {
          key: 0,
          height: "0.75rem",
          width: "2.5rem"
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("span", null, _toDisplayString(_unref(amount)), 1),
          (__props.usdLoss)
            ? (_openBlock(), _createBlock(TooltipText, {
                key: 0,
                "label-text": _unref(labelText),
                "tooltip-text": _unref(tooltipText),
                class: "ml-s1"
              }, null, 8, ["label-text", "tooltip-text"]))
            : _createCommentVNode("", true)
        ], 64))
  ]))
}
}

})